/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Audio_QInputs */

const en_road_dude_faq_audio_q = /** @type {(inputs: Road_Dude_Faq_Audio_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will the video use the original TikTok audio?`)
};

const zh_road_dude_faq_audio_q = /** @type {(inputs: Road_Dude_Faq_Audio_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成片会用原版 TikTok 音频吗？`)
};

/**
* | output |
* | --- |
* | "Will the video use the original TikTok audio?" |
*
* @param {Road_Dude_Faq_Audio_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_audio_q = /** @type {((inputs?: Road_Dude_Faq_Audio_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Audio_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_audio_q(inputs)
	return zh_road_dude_faq_audio_q(inputs)
});
export { road_dude_faq_audio_q as "road_dude.faq.audio.q" }